import MxTypography from "@rf-l1/MxTypography";
import { memo } from "react";

interface MessageIndicatorProps {
  status: string;
}

/**
 * MessageIndicator - Displays textual status based on form state
 *
 * Shows:
 * - "Cargando" when validating
 * - "Información faltante" when there are errors
 * - "Completado" when form is valid and dirty
 * - "Introducir información" for new forms
 */
const MessageIndicator = ({ status }: MessageIndicatorProps) => {
  switch (status) {
    case "loading":
      return (
        <MxTypography
          variant="overline"
          color="warning.main"
          my={0.5}
          whiteSpace="nowrap"
        >
          Cargando
        </MxTypography>
      );
    case "error":
      return (
        <MxTypography
          variant="overline"
          color="error.main"
          my={0.5}
          whiteSpace="nowrap"
        >
          Información faltante
        </MxTypography>
      );
    case "success":
      return (
        <MxTypography
          variant="overline"
          color="success.main"
          my={0.5}
          whiteSpace="nowrap"
        >
          Completado
        </MxTypography>
      );
    case "info":
      return (
        <MxTypography
          variant="overline"
          color="text.secondary"
          my={0.5}
          whiteSpace="nowrap"
        >
          Introducir información
        </MxTypography>
      );
    default:
      return null;
  }
};

// Memoize component with proper equality check
export default memo(MessageIndicator);
